// extracted by mini-css-extract-plugin
export default {"text":"text___f3XnT","arrowStyles":"arrowStyles___kVfo7","absoluteArrowStyles":"absoluteArrowStyles___WeYBO"};